// Assets
import { MdShare, MdEdit, MdDownload } from 'react-icons/md';
const Banner = ({
  handleYearChange,
  handleMonthChange,
  handleViewModeChange,
  handleFetchClick,
  years,
  year,
  month,
  viewMode,
  salaryDetails,
  downloadPDF,
}) => {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  return (
    <div className="mx-auto rounded-2xl bg-gradient-to-br from-brand-400 to-brand-600 px-4 pb-[140px] pt-9 font-dm md:w-[90%] md:pb-[70px] lg:h-[315px] lg:!px-[50px] lg:pt-[70px] xl:!px-[50px] 3xl:w-full">
      <div className="mb-3 flex justify-between">
        <div className="flex h-7 w-[110px] items-center justify-center rounded-[10px] bg-brand-400 text-sm font-bold text-white">
          Salary Invoice
        </div>

        <div className="flex gap-[12px]">
          <button
            onClick={downloadPDF}
            className="flex items-center justify-center rounded-lg bg-brand-400 p-2 text-xl text-white transition-opacity hover:cursor-pointer hover:opacity-80"
          >
            <MdDownload />
          </button>
        </div>
      </div>

      <div className="flex flex-col md:flex-row">
        <div className="mb-[24px]">
          <h2 className="text-xl font-bold text-white md:text-3xl lg:text-[38px]">
            {salaryDetails?.employeeId?.name || 'Employee Name'}
          </h2>
        </div>

        {/* <div className="mx-[50px] h-0 w-px bg-gray-600 md:h-[94px]" /> */}
      </div>

      <div className="flex flex-col gap-4 md:flex-row">
        <select
          value={viewMode}
          onChange={handleViewModeChange}
          className="rounded border border-none bg-gradient-to-br from-brand-400 to-brand-600 p-2 outline-none dark:text-navy-900"
        >
          <option value="monthly">Month</option>
          <option value="yearly">Year</option>
        </select>

        <select
          value={year}
          onChange={handleYearChange}
          className="rounded border border-none bg-gradient-to-br from-brand-400 to-brand-600 p-2 outline-none dark:text-navy-900"
        >
          <option value="">Select Year</option>
          {years.map((yr) => (
            <option key={yr} value={yr}>
              {yr}
            </option>
          ))}
        </select>

        {viewMode === 'monthly' && (
          <select
            value={month}
            onChange={handleMonthChange}
            className="rounded border border-none bg-gradient-to-br from-brand-400 to-brand-600 p-2 outline-none dark:text-navy-900"
          >
            {months.map((monthName, index) => (
              <option key={monthName} value={index + 1}>
                {monthName}
              </option>
            ))}
          </select>
        )}
      </div>
    </div>
  );
};

export default Banner;
